import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "rt_merak_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const GET_TIMEOUT = 8000;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.method === "get" && !config.timeout) config.timeout = GET_TIMEOUT;
  return config;
});

const MAX_RETRIES = 2;
const RETRY_STATUSES = [502, 503, 504, 520, 521, 522, 523, 524];

// Retry read-only requests on transient gateway/network failures (e.g. Cloudflare 520).
api.interceptors.response.use(undefined, async (error) => {
  const config = error.config;
  const status = error.response?.status;
  const transient = !error.response || RETRY_STATUSES.includes(status);
  if (!config || config.method !== "get" || !transient || (config.__retries || 0) >= MAX_RETRIES) {
    throw error;
  }
  config.__retries = (config.__retries || 0) + 1;
  await new Promise((resolve) => setTimeout(resolve, 600 * config.__retries));
  return api(config);
});

export const mediaUrl = (id) => `${API_BASE}/media/${id}?token=${encodeURIComponent(tokenStore.get() || "")}`;

export function formatApiError(err, fallback = "Terjadi kesalahan. Silakan coba lagi.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) {
    if (err?.code === "ECONNABORTED") return "Koneksi lambat, server belum merespons. Silakan coba lagi.";
    return err?.message === "Network Error" ? "Koneksi terputus. Periksa internet Anda." : fallback;
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ") || fallback;
  }
  if (typeof detail.msg === "string") return detail.msg;
  return fallback;
}
